module.exports = __webpack_public_path__ + "static/media/smi-cover.75c469a6.jpg";